'use client';

import { Grid2, Link, Stack, Typography } from '@mui/material';
import Image from 'next/image';
import { useRouter } from 'next/navigation';

import { icons } from '@/assets/icons';
import { backgrounds } from '@/assets/materials';
import { FORM_URL } from '@/global/configs/common';

import HexagonalButton from './bases/HexagonalButton';

export const OurMission = () => {
  const router = useRouter();

  return (
    <Stack
      width={'100%'}
      height={'100%'}
      flexGrow={1}
      paddingX={{ xs: '24px', sm: '80px' }}
      paddingY={{ xs: '44px', sm: '50px' }}
      alignItems={'center'}
      component={'section'}
      position={'relative'}>
      <Stack gap={{ xs: 3, sm: 7 }} width={'min(1280px, 100%)'} zIndex={2} alignItems={'center'}>
        <Stack
          width={'100%'}
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={'center'}
          justifyContent={'center'}
          gap={{ xs: '40px', sm: '240px' }}>
          <Stack gap={{ xs: 3, sm: 5 }} alignItems={'center'} width={'min(100%, 420px)'}>
            <Image
              width={420}
              height={420}
              src={backgrounds.hex_1}
              alt={'hex 1'}
              className={'w-[327px] h-[327px] sm:w-[420px] sm:h-[420px]'}
            />
            <Typography
              color={'white'}
              textAlign={'center'}
              className={'mix-blend'}
              variant={'bodyLarge'}
              fontSize={{ xs: '14px', sm: '18px' }}
              sx={{ opacity: 1 }}>
              <Typography fontSize={{ xs: '14px', sm: '18px' }} component={'span'} color={'#9C9691'} fontWeight={'700'}>
                We focus on empowering project ecosystems
              </Typography>{' '}
              with an innovative platform and seamless user experiences through our services.
            </Typography>
          </Stack>
          <Stack gap={{ xs: 3, sm: 5 }} alignItems={'center'} width={'min(100%, 420px)'}>
            <Image
              width={420}
              height={420}
              src={backgrounds.hex_2}
              alt={'hex 2'}
              className={'w-[327px] h-[327px] sm:w-[420px] sm:h-[420px]'}
            />
            <Typography
              color={'white'}
              textAlign={'center'}
              className={'mix-blend'}
              variant={'bodyLarge'}
              fontSize={{ xs: '14px', sm: '18px' }}
              sx={{ opacity: 1 }}>
              <Typography fontSize={{ xs: '14px', sm: '18px' }} component={'span'} color={'#E7B35E'} fontWeight={'700'}>
                Our mission is to accelerate innovative projects
              </Typography>{' '}
              by providing distributed solutions and sustainable funding models.
            </Typography>
          </Stack>
        </Stack>
        <Stack width={'219px'}>
          <Link href={'/about-us'} style={{ textDecoration: 'none' }}>
            <HexagonalButton variant={'danger'} label={'READ OUR STORY'} />
          </Link>
        </Stack>
      </Stack>

      <Stack zIndex={1} position={'absolute'} top={0} left={0} right={0} bottom={0}>
        <Image src={icons.ic_wave_section_2} alt={''} layout={'fill'} objectFit={'cover'} />
      </Stack>
    </Stack>
  );
};
